import Handlebars from 'handlebars';

Handlebars.registerHelper('upper', function (aString?: string) {
  return aString?.toUpperCase() ?? '';
});

export const hb = Handlebars;
